import { createContext, useContext } from "react";
import type { ReactNode } from "react";

type WidgetEditCtx = {
  isEdit: boolean;
  cardTitle?: string;
  editRight: ReactNode;
  renaming: boolean;
  renameInput: ReactNode;
};

export const WidgetEditContext = createContext<WidgetEditCtx>({
  isEdit: false,
  cardTitle: undefined,
  editRight: null,
  renaming: false,
  renameInput: null,
});

export function useWidgetEdit() {
  return useContext(WidgetEditContext);
}
